// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e63fcf08","488":"b7a46366","977":"e74c5593"}[chunkId] + ".chunk.js";
};